// The open entity's own FILES, in the one shape every surface that draws them wants
// (frame 40007893:378129): the Work-board's 14px chips, and the "open files" cards under an
// expanded item in the Tasks timeline.
//
// A document arrives as `{ id, timelineId, filename, contentType, hasThumbnail }` — the batch
// document read (document/timelines/list). The two surfaces then each asked the same three
// questions of it (is it a picture? what do I call it? can I show a thumbnail?), which is exactly
// the kind of duplication that lets two panes describe the same file differently. So they are
// answered once, here, and both surfaces render whatever comes back.

import { isImageAttachment } from '@/lib/globalTimelineFeed'

/** A document's own extension, lower-cased and without its dot — '' when the name carries none. */
export function fileExtension(filename) {
  const name = String(filename || '')
  const dot = name.lastIndexOf('.')
  return dot > 0 ? name.slice(dot + 1).toLowerCase() : ''
}

/**
 * Is this document a picture? The content type when the store knew one, else the file name's
 * extension — the same rule the timeline feed's attachments use (`isImageAttachment`), reached
 * through the document's own field names rather than restated here.
 */
export const isImageDoc = (d) => isImageAttachment({ contentType: d?.contentType, extension: fileExtension(d?.filename) })

/**
 * The documents, ready to draw: `{ id, name, isImage, hasThumbnail }`.
 *
 * `hasThumbnail` is what decides whether a thumbnail is FETCHED at all — the server says so on the
 * document record, and asking for one it does not hold costs a request per card to be answered with
 * a 404. Absent means "it did not say": pictures are tried anyway (older document rows carry no
 * such field), everything else takes its glyph.
 */
export function fileCards(docs) {
  return (docs || []).filter(d => d && d.id).map((d) => {
    const isImage = isImageDoc(d)
    return {
      id: d.id,
      name: String(d.filename || '').trim() || 'Attachment',
      contentType: d.contentType || '',
      isImage,
      hasThumbnail: d.hasThumbnail === undefined || d.hasThumbnail === null ? isImage : !!d.hasThumbnail,
    }
  })
}

export default fileCards
